<template>

       <div
        class="fl-post-grid-image"
        :style="{ backgroundImage:'url(' + postObj.images.large_image + ')' }"
        >
            <a :href="postObj.link" :target="hrefTarget">
                <div v-if="parseInt(moduleSettings.show_categories) === 1"
                    class="fl-post-grid-term"
                    :class="labelToClass"
                >
                    <MetaTerms :postObj="postObj" :moduleSettings="moduleSettings" :postLabel="postLabel" :postTerm="postTerm"></MetaTerms>
                </div>
            </a>
    </div>

</template>

<script>
import MetaTerms from './MetaTerms.vue'

export default {
  props: {
    postObj: {
      type: Object
    },
    hrefTarget: {
      type: String
    },
    moduleSettings: {
      type: Object
    },
    postLabel: {
      type: String
    },
    postTerm: {
      type: String
    }
  },
  computed: {
    labelToClass: function () {
      const sourceIndex = parseInt(this.postObj.source)
      const clean = 'feed-source-label-' + sourceIndex
      return clean
    }
  },
  components: {
    MetaTerms
  }
}
</script>
